module.exports = __webpack_public_path__ + "img/logo.e65e8d83.png";